<template>
    <v-edit-dialog :return-value.sync="item.memo" large cancel-text="취소" save-text="저장" v-on="{ save }">
        <slot />
        <template #input>
            <v-sheet class="pt-3">
                <v-text-field v-model="item.index" hide-details dense outlined />
            </v-sheet>
        </template>
    </v-edit-dialog>
</template>

<script>
export default {
    props: {
        value: { type: Object, default: () => ({}) },
    },
    data: () => ({
        item: {},
    }),
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.item = JSON.parse(JSON.stringify(this.value));
        },
        save() {
            let { _id, index } = this.item;
            let form = { _id, index };

            this.$emit("update", form);
        },
    },
};
</script>

